import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { FAQ } from 'src/app/models/um/organization';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq-modal',
  templateUrl: './faq-modal.component.html',
  styleUrls: ['./faq-modal.component.scss']
})
export class FaqModalComponent implements OnInit {
  @Input() public Content: any;
  formFields;
  loiOptions = chooseOptionsConstant;
  isautocode: boolean = false;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  faq: FAQ;
  modules: any[];
  TargetUserlist: any[] = [];
  ist: boolean = false;
  eap: boolean = false;
  grants: boolean = false;
  active: boolean = false;
  istDisplayName: string = '';
  eapDisplayName: string = '';
  grantsDisplayName: string = '';
  ApplicationTypeList: any = [];
  MappedApplications: any = [];
  moduleID: string = "";
  faqsForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    CODE: new UntypedFormControl(null),
    QUESTION: new UntypedFormControl(null),
    ANSWER: new UntypedFormControl(null),
    IS_FOR_IST: new UntypedFormControl(false),
    IS_FOR_EAP: new UntypedFormControl(false),
    IS_FOR_GRANTS: new UntypedFormControl(false),
    RECORD_STATE: new UntypedFormControl(true),
    TARGET_USER_TYPE: new UntypedFormControl("-1"),
    ApplicationType: new UntypedFormControl([], Validators.required)
    // ApplicationType:new UntypedFormControl("")
  });
  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    selector: 'editor#bodyeditor',
    suffix: '.min',
    statusbar: false,
    height: '200px !important',
    readonly: 1,
    paste_data_images: true,
    menubar: true,
    toolbar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks fullscreen',
      'insertdatetime media table paste'
    ]
  };
  tooltipValue: any;
  constructor(
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) {
  }

  ngOnInit() {

    this.TargetUserlist.push({
      label: "Select",
      value: "",
      checked: true

    });

    this.TargetUserlist.push({
      label: "Internal",
      value: 'I'
    });

    this.TargetUserlist.push({
      label: "External",
      value: 'E'
    });

    this.TargetUserlist.push({
      label: "Both",
      value: 'B'
    });

    this.faq = new FAQ();
    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getRFIByID('api/faq/getfaqbyid/' + this.Content.content.id).subscribe((result) => {
        this.faq = result;
        this.moduleID = result['MODULES'];
        this.setForm(result);
        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.faqsForm.disable({ emitEvent: false });
          }, 100);
        }
      });
    }
    else {
      this.faq = new FAQ();
      this.faq.IS_FOR_IST = false;
      this.faq.IS_FOR_EAP = false;
      this.faq.IS_FOR_GRANTS = false;
      this.faq.RECORD_STATE = 1;
      this.setForm(this.faq);
    }
    this.getModules();

  }

  getApplicationtypes() {
    this.faqsForm.controls["ApplicationType"].setValue([]);
    this.summaryService.GetData("api/faq/getapplicationTypes/"+this.moduleID+"/"+ this.Content.content.id).subscribe((result: any) => {
      if (result) {
        this.ApplicationTypeList = result;
        if(this.Content.heading=="Add")
        {
          setTimeout(() => {
            this.MappedApplications = [];
            this.faqsForm.controls["ApplicationType"].setValue([]);
            this.ApplicationTypeList.forEach(element => {
              this.MappedApplications.push(element.value);
            });
            this.faqsForm.controls["ApplicationType"].setValue(this.MappedApplications);
            this.changeVal("");
          }, 100)
        }
      
      }
    });
  }

 
  changeVal($event) {
    setTimeout(() => {
      let selectedtype :any;
      selectedtype = this.faqsForm.controls["ApplicationType"].value;
      if (selectedtype != "" && selectedtype != undefined && selectedtype != null) {
        let TypeLabel = this.ApplicationTypeList.filter((item) => {
          return selectedtype.indexOf(item.value) > -1;
        })
        let labellist = [];
        TypeLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }
    }, 200);
  }

  save() {
    if (this.validateControls()) {
      const formdata = this.faqsForm.value;
      formdata.QUESTION = formdata.QUESTION == null ? null : formdata.QUESTION == undefined ? undefined : formdata.QUESTION.trim();
      formdata.ANSWER = formdata.ANSWER == null ? null : formdata.ANSWER == undefined ? undefined : formdata.ANSWER.trim();
      formdata['MappedAppTypesIDs'] = formdata.ApplicationType.join(",");
      let tempList = this.ApplicationTypeList.filter((item) => {
        return formdata['MappedAppTypesIDs'].indexOf(item.value) > -1;
      });
      tempList.forEach((obj, index) => {
        if (index == 0)
          formdata['MappedAppTypesNames'] = obj.label; 
        else
          formdata['MappedAppTypesNames'] = formdata['MappedAppTypesNames'] + "," + obj.label;
      });
      if (this.Content.content && this.Content.heading === 'Add') {
        this.summaryService.Insert('api/faq/insert', formdata).subscribe(result => {
          if (result.Status === 0) {

            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'FAQ  ' + this.faqsForm.controls['QUESTION'].value  + '  added Successfully.' } } });
            this.commonservice.SuccessBanner('FAQ ' + "'" + this.faqsForm.controls['QUESTION'].value + "'" + ' added successfully');

            this.modalRef.close();

          }
          else {
            this.commonservice.ValidationBanner(result.Message);
            //  this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
            //   this.commonservice.ErrorBanner("Error message");
          }
        })

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.Insert('api/faq/update', formdata).subscribe(result => {
          if (result.Status === 0) {
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'FAQ '+  this.faqsForm.controls['QUESTION'].value +' Updated Successfully.' } } });

            this.modalRef.close();
            this.commonservice.SuccessBanner('FAQ ' + "'" + this.faqsForm.controls['QUESTION'].value + "'" + ' updated successfully');
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
            // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: result.Message } } });
            // this.commonservice.ErrorBanner(result.Message);
          }
        })
      }
    }
  }

  setForm(result: FAQ): void {
    // if (this.Content.heading != "Add")
    if (result != null) {
      this.getApplicationtypes();
      //  this.ApplicationTypeList = result['MappedApps'];
      // if(this.Content.heading == 'Edit')
      if (result['MappedApps'] != undefined) {
        result['MappedApps'].forEach(element => {
          this.MappedApplications.push(element.value);
        });
      }
      else {
        this.MappedApplications = [];
      }
    }
    this.faqsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      QUESTION: new UntypedFormControl(result.QUESTION),
      ANSWER: new UntypedFormControl(result.ANSWER),
      IS_FOR_IST: new UntypedFormControl(result.IS_FOR_IST),
      IS_FOR_EAP: new UntypedFormControl(result.IS_FOR_EAP),
      IS_FOR_GRANTS: new UntypedFormControl(result.IS_FOR_GRANTS),
      RECORD_STATE: new UntypedFormControl(result.RECORD_STATE),
      ApplicationType: new UntypedFormControl(this.MappedApplications),
      TARGET_USER_TYPE: new UntypedFormControl(result.TARGET_USER_TYPE)
    });
  }

  private getForm(): FAQ {
    const formModel = this.faqsForm.getRawValue();
    if (formModel.ANSWER != null && formModel.ANSWER != undefined) {
      formModel.ANSWER = formModel.ANSWER.replaceAll("<a", "<a target='_blank'")
    }
    formModel.QUESTION = formModel.QUESTION == null ? null : formModel.QUESTION == undefined ? undefined : formModel.QUESTION.trim();
    formModel.ANSWER = formModel.ANSWER == null ? null : formModel.ANSWER == undefined ? undefined : formModel.ANSWER.trim();
    //debugger;
    let faq = new FAQ();
    faq = {
      ID: formModel.ID || '',
      QUESTION: formModel.QUESTION || '',
      ANSWER: formModel.ANSWER || '',
      IS_FOR_IST: formModel.IS_FOR_IST,
      IS_FOR_EAP: formModel.IS_FOR_EAP,
      IS_FOR_GRANTS: formModel.IS_FOR_GRANTS,
      RECORD_STATE: formModel.RECORD_STATE == true ? 1 : 0,
      TARGET_USER_TYPE: formModel.TARGET_USER_TYPE,
      FAQ_APPLICATION_TYPES: formModel.ApplicationType
    };
    return faq;
  }

  valueChange(module, $event): void { // checkbox event
   // debugger
    switch (module) {
      case "IST":
        this.faqsForm.controls['IS_FOR_IST'].setValue($event.target.checked);
        this.faq.IS_FOR_IST = $event.target.checked;

        break;

      case "EAP":
        this.faqsForm.controls['IS_FOR_EAP'].setValue($event.target.checked);
        this.faq.IS_FOR_EAP = $event.target.checked;
        break;

      case "GRANTS":
        this.faqsForm.controls['IS_FOR_GRANTS'].setValue($event.target.checked);
        this.faq.IS_FOR_GRANTS = $event.target.checked;
        break;

      case "ACTIVE":
        this.faqsForm.controls['RECORD_STATE'].setValue($event);
        this.faq.RECORD_STATE = $event.target.checked;
        break;
    }
 //   if (this.faq.IS_FOR_IST == this.faq.IS_FOR_GRANTS) { this.moduleID = "-1"; }

    if (this.faq.IS_FOR_IST && this.faq.IS_FOR_GRANTS) { this.moduleID = "-1"; }
    else if (this.faq.IS_FOR_IST && this.faq.IS_FOR_GRANTS == false) { this.moduleID = "2"; }
    else if (this.faq.IS_FOR_IST == false && this.faq.IS_FOR_GRANTS) { this.moduleID = "4"; }
    else { this.moduleID = "0"; }


    this.getApplicationtypes();
  }

  getModules() {

    this.summaryService.getModuleByOrgId('api/common/getmodulesbyid').subscribe((result) => {
      this.modules = result;
      let len = this.modules.length;
      for (let i = 0; i < len; i++) {
        switch (this.modules[i].CODE) {
          case "IST":
            this.istDisplayName = this.modules[i].NAME;
            this.ist = true;
            break;
          case "EAP":
            this.eapDisplayName = this.modules[i].NAME;
            this.eap = true;
            break;
          case "GRA":
            this.grantsDisplayName = this.modules[i].NAME;
            this.grants = true;
            break;
          // case "Active":
          //   this.active = false;
        }
      }
    });
  }


  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.faqsForm.value;
    if (formData.QUESTION === null || formData.QUESTION === "" || formData.QUESTION === undefined) {
      $("#QUESTION").addClass("ng-touched ng-invalid validate-error");
      $("#QUESTION").removeClass("ng-untouched ng-valid");
      message += "Please enter Question <br/>";
      isValid = false;
    } else if (formData.QUESTION != null && formData.QUESTION != undefined && formData.QUESTION.trim() == "") {
      $("#QUESTION").addClass("ng-touched ng-invalid validate-error");
      $("#QUESTION").removeClass("ng-untouched ng-valid");
      message += "Please enter Question <br/>";
      isValid = false;
    }
    else {
      $("#QUESTION").addClass("ng-untouched ng-valid");
      $("#QUESTION").removeClass("ng-touched ng-invalid validate-error");
    }

    let ischecked = true;
    formData.RECORD_STATE = this.faqsForm.controls["RECORD_STATE"].value ? 1 : 0;
    if (this.faq.IS_FOR_IST === false && this.faq.IS_FOR_EAP === false && this.faq.IS_FOR_GRANTS === false) {
      message += "Please select Applicable Programs<br/>";
      isValid = false;
      ischecked = false;
    }


    if (formData.TARGET_USER_TYPE === null || formData.TARGET_USER_TYPE === "" || formData.TARGET_USER_TYPE === undefined) {
      $("#TARGET_USER_TYPE").addClass("ng-touched ng-invalid validate-error");
      $("#TARGET_USER_TYPE").removeClass("ng-untouched ng-valid");
      message += "Please select Target User<br/>";
      isValid = false;
    }
    else {
      $("#TARGET_USER_TYPE").addClass("ng-untouched ng-valid");
      $("#TARGET_USER_TYPE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (ischecked) {
      if (formData.ApplicationType === null || formData.ApplicationType === "" || formData.ApplicationType.length == 0 ||
        formData.ApplicationType === undefined) {
        $("#ApplicationType").addClass("ng-touched ng-invalid validate-error");
        $("#ApplicationType").removeClass("ng-untouched ng-valid");
        message += "Please select Application Type<br/>";
        isValid = false;
      }
      else  if (formData.ApplicationType != null &&  formData.ApplicationType != undefined)
      {
        let selectedIDs = formData.ApplicationType.join(",")
        let InactiveAvilable = this.ApplicationTypeList.filter((item) => {
          return (selectedIDs.indexOf(item.value) > -1 && item.IsActive == false);
        })[0];
        if (InactiveAvilable != undefined && InactiveAvilable != null) {
          message += "Please remove inactive application type to save the details<br/>";
          isValid = false;
        }
      }
      else {
        $("#ApplicationType").addClass("ng-untouched ng-valid");
        $("#ApplicationType").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (formData.ANSWER === null || formData.ANSWER === "" || formData.ANSWER === undefined) {
      $("#ANSWER").addClass("ng-touched ng-invalid validate-error");
      $("#ANSWER").removeClass("ng-untouched ng-valid");
      message += "Please enter Answer<br/>";
      isValid = false;
    } else if (formData.ANSWER != null && formData.ANSWER != undefined && formData.ANSWER.trim() == "") {
      $("#ANSWER").addClass("ng-touched ng-invalid validate-error");
      $("#ANSWER").removeClass("ng-untouched ng-valid");
      message += "Please enter Answer<br/>";
      isValid = false;
    }
    else {
      $("#ANSWER").addClass("ng-untouched ng-valid");
      $("#ANSWER").removeClass("ng-touched ng-invalid validate-error");


    }



    if (!isValid)
      this.commonservice.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: message } } });
    return isValid;
  }

 
}
